export const GroupOrUserInputServiceReader = Symbol('GroupOrUserInputServiceReader');
